// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__P9OLS","head__title":"styles_head__title__2Ggx8"};